const LOCALE_CURRENCY = 'en-US'

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat(LOCALE_CURRENCY, {
    style: 'currency',
    currency: 'USD',
  }).format(amount)
}
